module.exports = __webpack_public_path__ + "static/media/Snappy.ff6a2c39.svg";